<template>
  <div class="my-10">
    <div class="flex justify-center px-4 items-center">
      <h1 class="text-3xl font-bold text-center">{{ __("Edit brand") }}</h1>
    </div>

    <div class="bg-white p-4 shadow-md mt-10 ">
      <div class="max-w-2xl w-full mx-auto my-10 flex flex-col items-center">
        <form @submit.prevent="submitForm" class="w-full">
          <div>
            <text-input v-model="form.name" :data-error="error('name', `carMake.${carMake.id}`)" class="w-full pb-8" :label="__('Name')"/>
          </div>

          <fieldset class="border border-gray-300 rounded p-6 mb-6">
            <legend class="px-2 text-sm font-semibold text-gray-600 uppercase tracking-wide">
              {{ __("Report card settings") }}
            </legend>
            <p class="text-sm text-gray-500 leading-relaxed mb-5">
              {{ __("Controls the per-brand report card behaviour. When disabled, the report card tab is hidden on jobs and the status guard is skipped entirely.") }}
            </p>
            <label class="flex items-start gap-3 text-gray-700">
              <input type="checkbox" v-model="form.report_card_enabled" class="mt-1 border focus:ring focus:border-coral-400">
              <span class="leading-snug">
                <span class="font-semibold">{{ __("Enable report card") }}</span>
                <span class="block text-xs text-gray-500 leading-relaxed mt-1">{{ __("Master switch. Turn off to hide everything below for this brand.") }}</span>
              </span>
            </label>
            <div v-if="form.report_card_enabled" class="mt-5 ml-6 pl-4 border-l-2 border-gray-200 space-y-5 text-gray-700">
              <label class="flex items-start gap-3">
                <input type="checkbox" v-model="form.report_card_mandatory" class="mt-1 border focus:ring focus:border-coral-400">
                <span class="leading-snug">
                  <span>{{ __("Report card mandatory to finalize job") }}</span>
                  <span class="block text-xs text-gray-500 leading-relaxed mt-1">{{ __("Block setting the job status to Completed unless the report card is filled in and a PDF has been generated.") }}</span>
                </span>
              </label>
              <label class="flex items-start gap-3">
                <input type="checkbox" v-model="form.pdf_show_sro_time" class="mt-1 border focus:ring focus:border-coral-400">
                <span class="leading-snug">{{ __("Show SRO time column on PDF") }}</span>
              </label>
              <label class="flex items-start gap-3">
                <input type="checkbox" v-model="form.pdf_show_condition_code" class="mt-1 border focus:ring focus:border-coral-400">
                <span class="leading-snug">{{ __("Show condition code column on PDF") }}</span>
              </label>
            </div>
          </fieldset>

          <div class="flex flex-col items-center">
            <image-input v-model="form.brandImage" :image-url="carMake.brand_image_url" :data-error="error('brandImage', `carMake.${carMake.id}`)" class="w-full" type="file"/>
          </div>

          <div class="flex justify-center items-center mt-4">
            <loading-button :loading="sendingForm" class="btn-primary" type="submit">{{ __("Save brand") }}</loading-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import Layout from '@/Shared/Layout';
  import TextInput from '@/Shared/TextInput';
  import ImageInput from '@/Shared/ImageInput';
  import LoadingButton from '@/Shared/LoadingButton';
  import Icon from '@/Shared/Icon';

  export default {
    layout: Layout,
    metaInfo() {
      return {
        title: this.__("Edit brand")
      }
    },
    props: {
      carMake: Object
    },
    data() {
      return {
        sendingForm: false,
        form: {
          name: this.carMake.name,
          report_card_enabled: this.carMake.report_card_enabled !== false,
          report_card_mandatory: this.carMake.report_card_mandatory !== false,
          pdf_show_sro_time: this.carMake.pdf_show_sro_time !== false,
          pdf_show_condition_code: this.carMake.pdf_show_condition_code !== false,
          brandImage: null,
        }
      }
    },
    components: {
      Layout,
      TextInput,
      ImageInput,
      LoadingButton,
      Icon
    },
    methods: {
      submitForm() {
        this.sendingForm = true;
        let data = new FormData();
        data.append('name', this.form.name || '');
        data.append('report_card_enabled', this.form.report_card_enabled ? 1 : 0);
        data.append('report_card_mandatory', this.form.report_card_mandatory ? 1 : 0);
        data.append('pdf_show_sro_time', this.form.pdf_show_sro_time ? 1 : 0);
        data.append('pdf_show_condition_code', this.form.pdf_show_condition_code ? 1 : 0);
        data.append('brandImage', this.form.brandImage || '');
        data.append('_method', 'put');

        this.$inertia.post(this.route('carMakes.update', {carMake: this.carMake.id}), data)
          .then(() => {
            this.sendingForm = false;
          });
      }
    }
  }
</script>
